import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

const Checkout = () => {
  const { id } = useParams();
  const [book, setBook] = useState([]);
  const { bookName, price, image, authorName } = book;
  // console.log(name, seatFare)
  const user = JSON.parse(localStorage.getItem("user"));
  const [customerData, setCustomerData] = useState({
    userName: user.name,
    email: user.email,
    bookName: bookName,
    authorName: authorName,
    Quantity: "1",
    Price: price,
    image: image,
  });
  // console.log(customerData);

  const handleCheckout = (e) => {
    e.preventDefault();
    fetch("https://infinite-cliffs-81680.herokuapp.com/customerOrder", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(customerData),
    })
      .then((res) => res.json())
      .then(
        (data) => console.log(data),
        alert("Are you sure to order this book???")
      );
  };

  useEffect(() => {
    fetch(`https://infinite-cliffs-81680.herokuapp.com/book/${id}`)
      .then((res) => res.json())
      .then((data) => {
        setBook(data);
        const newCustomerData = { ...customerData };
        newCustomerData.userName = user.name;
        newCustomerData.email = user.email;
        newCustomerData.bookName = bookName;
        newCustomerData.Price = price;
        newCustomerData.image = image;
        newCustomerData.authorName = authorName;

        setCustomerData(newCustomerData);
      });
  });

  return (
    <div className="container">
      <h1>Checkout</h1>
      <div>
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th scope="col">Serial No</th>
              <th scope="col">Name</th>
              <th scope="col">Quantity</th>
              <th scope="col">Price</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">1</th>
              <td>{bookName}</td>
              <td>1</td>
              <td>${price}</td>
            </tr>

            <tr>
              <td colspan="3">Total</td>
              <td>${price}</td>
            </tr>
          </tbody>
        </table>
        <div className=" d-flex justify-content-end me-5">
          <button onClick={handleCheckout} className="btn btn-primary">
            Checkout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
